module.exports = new __parcel__URL__("product-roadmap-project-icon.7eb40fb0.svg").toString();